import { writing } from "../data/site";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const Writing = () => {
  const w = writing;
  return (
    <section className="section writing" id="writing">
      <SectionHead
        num="05"
        kicker="Writing"
        title="Notes from the keyboard."
        sub="Making AI approachable — a series for curious, non-technical readers on understanding and using AI safely."
      />
      <div className="wrap">
        <ul className="post-list">
          {w.posts.map((post, i) => (
            <Reveal key={i} delay={i * 80}>
              <li className="post">
                <a href={post.link ?? w.link} target="_blank" rel="noreferrer">
                  <span className="post-title">{post.title}</span>
                  <span className="post-meta">{post.meta}</span>
                  <span className="post-arrow">→</span>
                </a>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Writing;
